// // subjects/redux/questionBankThunk.js
// import { createAsyncThunk } from "@reduxjs/toolkit";
// import { API_URL_QUESTION_BANK } from "../../SchoolModule/Webservices/api";
// import { setEditingQuestion } from "./questionBankSlice";
// const API_BASE_URL = API_URL_QUESTION_BANK;
// export const fetchQuestionTypes = createAsyncThunk(
//   "questionBank/fetchQuestionTypes",
//   async (_, { rejectWithValue }) => {
//     try {
//       const response = await fetch(`${API_BASE_URL}/subjects/question-types`);
//       const data = await response.json();
//       return data;
//     } catch (error) {
//       return rejectWithValue(error.message);
//     }
//   }
// );

// export const addQuestionThunk = createAsyncThunk(
//   "questionBank/addQuestion",
//   async (
//     { questionData, classId, subjectId, chapterId, created_by },
//     { rejectWithValue }
//   ) => {
//     try {
//       const response = await fetch(`${API_BASE_URL}/questions`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           ...questionData,
//           class_id: parseInt(classId),
//           subject_id: parseInt(subjectId),
//           chapter_id: parseInt(chapterId),
//           created_by: parseInt(created_by),
//         }),
//       });

//       if (!response.ok) {
//         const error = await response.json();
//         return rejectWithValue(error.message || "Failed to add question");
//       }

//       return await response.json();
//     } catch (error) {
//       return rejectWithValue(error.message);
//     }
//   }
// );

// // Edit Question
// export const editQuestionThunk = createAsyncThunk(
//   "questionBank/editQuestion",
//   async (
//     { questionPayload, classId, subjectId, chapterId, userId },
//     { dispatch, rejectWithValue }
//   ) => {
//     try {
//       const response = await fetch(
//         `${API_BASE_URL}/questions/${questionPayload.question_id}`,

//         {
//           method: "PUT",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({
//             ...questionPayload,
//             class_id: parseInt(classId),
//             subject_id: parseInt(subjectId),
//             chapter_id: parseInt(chapterId),
//             updated_by: userId,
//           }),
//         }
//       );

//       if (!response.ok) {
//         const error = await response.json();
//         return rejectWithValue(error.message || "Failed to edit question");
//       }

//       dispatch(setEditingQuestion(null));
//       return await response.json();
//     } catch (error) {
//       return rejectWithValue(error.message);
//     }
//   }
// );

// //To fetch question as per the filters
// export const fetchQuestionsThunk = createAsyncThunk(
//   "questionBank/fetchQuestions",
//   async (
//     { classId, subjectId, chapterId, questionTypeId, created_by },
//     { rejectWithValue }
//   ) => {
//     try {
//       const queryParams = new URLSearchParams();
//       queryParams.append("class_id", classId);
//       queryParams.append("subject_id", subjectId);
//       queryParams.append("chapter_id", chapterId);
//       queryParams.append("created_by", created_by);
//       if (questionTypeId) {
//         queryParams.append("questionType", questionTypeId);
//       }

//       const response = await fetch(
//         `${API_BASE_URL}/questions?${queryParams.toString()}`
//       );
//       const data = await response.json();

//       if (!response.ok) {
//         throw new Error(data.message || "Failed to fetch questions");
//       }

//       return data;
//     } catch (error) {
//       return rejectWithValue(error.message);
//     }
//   }
// );

// //For variants
// export const fetchQuestionVariantsThunk = createAsyncThunk(
//   "questionBank/fetchVariants",
//   async ({ parentQuestionId }, { rejectWithValue }) => {
//     try {
//       const response = await fetch(
//         `${API_BASE_URL}/questions/${parentQuestionId}`
//       );
//       const data = await response.json();

//       if (!response.ok) {
//         throw new Error(data.message || "Failed to fetch questions.");
//       }

//       return data;
//     } catch (error) {
//       return rejectWithValue(error.message);
//     }
//   }
// );

// export const editVariantThunk = createAsyncThunk(
//   "questionBank/editVariant",
//   async ({ questionPayload }, { rejectWithValue }) => {
//     try {
//       const response = await fetch(
//         `${API_BASE_URL}/questions/${questionPayload.question_id}`,
//         {
//           method: "PUT",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify({
//             ...questionPayload,
//             //  created_by: questionPayload.created_by || userId,
//             //  updated_by: questionPayload.updated_by || userId,
//           }),
//         }
//       );

//       if (!response.ok) {
//         const error = await response.json();
//         return rejectWithValue(error.message || "Failed to update variant");
//       }

//       return await response.json();
//     } catch (error) {
//       return rejectWithValue(error.message || "Something went wrong");
//     }
//   }
// );
// subjects/redux/questionBankThunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import { getQuestionTypes, questions } from "../config";
import { setEditingQuestion } from "./questionBankSlice";
import { apiKeyHeader } from "../../../configs/ApiKeys";
export const fetchQuestionTypes = createAsyncThunk(
  "questionBank/fetchQuestionTypes",
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetch(getQuestionTypes, {
        method: "GET",
        headers: apiKeyHeader(),
      });
      const data = await response.json();
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const addQuestionThunk = createAsyncThunk(
  "questionBank/addQuestion",
  async (
    { questionData, classId, subjectId, chapterId, created_by },
    { rejectWithValue }
  ) => {
    try {
      const response = await fetch(questions, {
        method: "POST",
        headers: apiKeyHeader(),
        body: JSON.stringify({
          ...questionData,
          class_id: parseInt(classId),
          subject_id: parseInt(subjectId),
          chapter_id: parseInt(chapterId),
          created_by: parseInt(created_by),
        }),
      });

      if (!response.ok) {
        const error = await response.json();
        return rejectWithValue(error.message || "Failed to add question");
      }

      return await response.json();
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Edit Question
export const editQuestionThunk = createAsyncThunk(
  "questionBank/editQuestion",
  async (
    { questionPayload, classId, subjectId, chapterId, userId },
    { dispatch, rejectWithValue }
  ) => {
    try {
      const response = await fetch(
        `${questions}/${questionPayload.question_id}`,

        {
          method: "PUT",
          headers: apiKeyHeader(),
          body: JSON.stringify({
            ...questionPayload,
            class_id: parseInt(classId),
            subject_id: parseInt(subjectId),
            chapter_id: parseInt(chapterId),
            updated_by: userId,
          }),
        }
      );

      if (!response.ok) {
        const error = await response.json();
        return rejectWithValue(error.message || "Failed to edit question");
      }

      dispatch(setEditingQuestion(null));
      return await response.json();
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

//To fetch question as per the filters
export const fetchQuestionsThunk = createAsyncThunk(
  "questionBank/fetchQuestions",
  async (
    { classId, subjectId, chapterId, questionTypeId, created_by },
    { rejectWithValue }
  ) => {
    try {
      const queryParams = new URLSearchParams();
      queryParams.append("class_id", classId);
      queryParams.append("subject_id", subjectId);
      queryParams.append("chapter_id", chapterId);
      queryParams.append("created_by", created_by);
      if (questionTypeId) {
        queryParams.append("questionType", questionTypeId);
      }

      const response = await fetch(`${questions}?${queryParams.toString()}`, {
        method: "GET",
        headers: apiKeyHeader(),
      });
      const data = await response.json();

      console.log("data", data);
      if (!response.ok) {
        throw new Error(data.message || "Failed to fetch questions");
      }

      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

//For variants
export const fetchQuestionVariantsThunk = createAsyncThunk(
  "questionBank/fetchVariants",
  async ({ parentQuestionId }, { rejectWithValue }) => {
    try {
      const response = await fetch(`${questions}/${parentQuestionId}`, {
        method: "GET",
        headers: apiKeyHeader(),
      });
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Failed to fetch questions.");
      }

      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const editVariantThunk = createAsyncThunk(
  "questionBank/editVariant",
  async ({ questionPayload }, { rejectWithValue }) => {
    try {
      const response = await fetch(
        `${questions}/${questionPayload.question_id}`,
        {
          method: "PUT",
          headers: apiKeyHeader(),
          body: JSON.stringify({
            ...questionPayload,
            //  created_by: questionPayload.created_by || userId,
            //  updated_by: questionPayload.updated_by || userId,
          }),
        }
      );

      if (!response.ok) {
        const error = await response.json();
        return rejectWithValue(error.message || "Failed to update variant");
      }

      return await response.json();
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);
